import { FileReference } from "Domain/Model/FileReference/FileReference";

export const UPDATE_FILE_REFERENCE_SUCCESS = 'UPDATE_FILE_REFERENCE_SUCCESS';

export const updateFileReferenceSuccess = (payload: Record<string, FileReference>) => ({
    type: UPDATE_FILE_REFERENCE_SUCCESS,
    payload,
});
